<template>
  <div class="ph-special-main">
    <div class="pt-e-detail">

<!--      <div style="position: absolute;width: 100%;left: 0;top: 1.77rem;opacity: 0.7;z-index: 99999;">-->
<!--        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260706/1158d115f7c60f82b01d6543acf37d8c.jpg" alt="">-->
<!--      </div>-->

      <div class="pt-e-banner">
        <div class="pt-e-banner-txt">
          <div class="p-title">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260701/592045dcfd2efe89cff733a1cd95561e.png" alt="">
          </div>
          <p>Dental Scaler and Air Polisher</p>
        </div>
        <div class="pt-e-banner-img">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260706/9d1df46c9a294e9c496e967e9d0d5f52.jpg" alt="">
        </div>

        <div class="button-container">
          <viewButton @onclick="openVideoModal(videoList[0].previewVideo)"></viewButton>
        </div>
      </div>

      <div class="promotional-cover" v-observe-visibility="(isVisible) => handleVisibility(isVisible, 0)">
        <div class="progress">
          <circular-progress :progress="videoList[0].progress" :isPlaying="videoList[0].playing" index="0" @togglePlay="togglePlay"/>
        </div>
        <video class="background-video"
               :ref="videoList[0].ref"
               :src="videoList[0].video"
               muted
               playsinline
               loop
        ></video>
      </div>

      <div class="power-container">
        <h3 class="tit">POWER<br/>MEETS<br/>COMFORT</h3>
        <h4>New AirstreamNozzle Design</h4>
        <p class="desc">A new petal-shaped nozzle delivers<br/>a more focused water mist, </p>
        <p class="desc">balancing efficiency with patient comfort.<br/>Cleaning efficiency increased</p>
        <h3 class="num">35%</h3>

        <div class="model">
          <p class="model-tit previous">Previous Model</p>
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260707/6b19d8e8c1aaefe2702a94134d1963b7.png" alt="">
          <p class="model-tit new">New Model</p>
        </div>
      </div>


      <div class="feature-container">
        <div class="feature-bg">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260707/08621e80137ded368c38c160e5aec1fe.jpg" alt="" />
        </div>
        <div class="feature-content">
          <p>Low-noise airstream:</p>
          <p>75.8dB in commonly used settings,</p>
          <p>9dB quieter for a calmer experience</p>

          <p>Less impact (g):</p>
          <p>28.7%</p>
          <p class="line-height-14">Lower water and air impact at the same efficiency,<br/>ensuring greater patient comfort</p>
          <div class="params pt-e-c">
            <div class="pt-e">
              <p>Power level 6</p>
              <p>6.68g</p>
            </div>
            <p class="tit">PT-E</p>
          </div>
          <div class="params Standard-c">
            <div class="Standard">
              <p>Power level 6</p>
              <p>9.37g</p>
            </div>
            <p class="tit">Standard</p>
          </div>
        </div>
      </div>

      <div class="heating-system-container">
        <h4>Dual Heating System</h4>
        <p>
          Deliver warm water for both ultrasonic<br/>
          and airstream functions4 temperature settings:<br/>
          25°C, 30°C, 35°C, 40°C for airstream<br/>
          24°C, 28°C, 32°C, 36°C for scaling<br/>
          350W heating power: increased by 16.67%
        </p>
      </div>
      <div class="heating-system-img">
        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260707/ccd3e0c4e8d5d4420e776fbce03c0f61.jpg" alt="">
      </div>

      <div class="upgraded-airstream-container">
        <h4>Upgraded Airstream<br/>Handpiece with LED</h4>
        <p>
          Inbuilt LED light improves visibility<br/>
          and enhances operational precision<br/>
          for better treatment outcomes.
        </p>
      </div>
      <div class="upgraded-airstream-img">
        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260707/944e28a93db41fd43a67765c33d3f6f0.jpg" alt="">
      </div>

      <div class="titanium-alloy-container">
        <div class="titanium-alloy-content">
          <h4>Titanium Alloy Handpiece</h4>
          <p>
            Crafted with high-strength titanium alloy，<br/>
            offering superior biocompatibility,<br/>
            greater corrosion resistance,<br/>
            and enhanced wear resistance.
          </p>
        </div>
        <div class="titanium-alloy-img">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260707/7f5f9dddb289196bbedafae70fa38c51.png" alt="">
        </div>
      </div>


      <div class="power-container precision-container">
        <h3 class="tit">VERSATILITY<br/>MEETS<br/>PRECISION</h3>
        <h4>Six Ultrasonic Modes</h4>
        <p class="desc">Designed to meet different needs.</p>
        <div class="step-use">
          <div class="step-item">
            <h5 class="letter">G</h5>
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/b820988340060e46d743af1983b8662e.png" alt="">
            <div class="explain-c">
              <div class="explain-b">
                <div>
                  <p class="explain-tit">Ultra scaling</p>
                  <p>For rapid and efficient<br/>removal of large<br/>calculus,reducing<br/>procedure time</p>
                </div>
                <div>
                  <p class="explain-tit">Soft scaling</p>
                  <p>For gentle removal<br/>of stains and soft<br/>deposits, minimizing<br/>patient discomfort</p>
                </div>
              </div>
            </div>
          </div>
          <div class="step-item">
            <h5 class="letter">P</h5>
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/926e6d919b69c2e8c5393dbcfc50b6ec.png" alt="">
            <div class="explain-c">
              <div class="explain-b">
                <div>
                  <p class="explain-tit">Perio</p>
                  <p>For effective biofilm<br/>removal,protecting<br/>soft tissue and<br/>minimizing trauma</p>
                </div>
                <div>
                  <p class="explain-tit">Implant<br/>maintenance</p>
                  <p>Six adjustable levels<br/>for precise and<br/>safe implant<br/>surface cleaning</p>
                </div>
              </div>
            </div>
          </div>
          <div class="step-item">
            <h5 class="letter">E</h5>
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/10ba719144265e83bdc5c374a53220e8.png" alt="">
            <div class="explain-c">
              <div class="explain-b">
                <div>
                  <p class="explain-tit">Endo</p>
                  <p>Precise ultrasonic<br/>power optimizes root <br/>canal preparation and<br/>enhances treatment success</p>
                </div>
                <div>
                  <p class="explain-tit">Irrigation</p>
                  <p>Six safety levels<br/>ensure effective<br/>debris removal<br/>whileprotecting dentin</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="scaling">
        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/fc89c83bdd72d62226ebbcc9a91fad9f.png" alt="">
      </div>

      <div class="convenience-container">
        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/f57e5a0c3f9ca8c5af7a0065b287e6a9.jpg" alt="">
        <div class="convenience-content">
          <div class="main-txt">
            <h3 class="tit">EFFICIENCY<br/>MEETS<br/>CONVENIENCE</h3>
            <h4>One-Touch<br/>Dual-Waterway Cleaning</h4>
            <p class="desc">One-touch auto cleaning for both ultrasonic<br/>and airstream waterways<br/>
              Two cleaning durations optional: 120s, 20s<br/>
              Saves time and ensures the device is<br/>ready for the next procedure</p>
          </div>
          <div class="params">
            <p>120s</p>
            <p>20s</p>
          </div>

          <div class="powder-container">
            <div class="powder-container-info">
              <h4>IlluminatedPowder Container</h4>
              <p class="desc">LED-lit powder container makes it easier to<br/>differentiate between powders, <br/>
                streamlining clinical operations:</p>
            </div>

          </div>



      </div>

        <div class="clinical-operations">
          <div class="clinical-operation">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/f40c3443ad2baf29a84ce98e93c7d82b.jpg" alt="">
            <p>Green light: erythritol/glycine powder</p>
          </div>
          <div class="clinical-operation">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/afcbd71a53d5f7c2801635f212b012a8.jpg" alt="">
            <p>White light: sodium bicarbonate powder</p>
          </div>
        </div>

        <div class="convenience-upgraded">

          <div class="convenience-upgraded-content">
            <div class="ps">
              <h4>Pinch Valve Upgraded<br/>to Ceramic Valve</h4>
              <p class="desc">Lower risk of tube rupture<br/>
                Greater operational stability.</p>
            </div>

            <div class="convenience-upgraded-container">
              <div class="before">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/fec86e439a2ec72a0415e7a93cb52820.png" alt="">
                <p>PT-E</p>
              </div>
              <div class="after">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/d50f86766ef7d616b6dd2aa1b5ead5ef.png" alt="">
                <p>Standard</p>
              </div>

            </div>
          </div>
          <div class="glow"></div>
        </div>

        <div class="intelligent-interface">
          <div class="intelligent-interface-container">
            <div class="interface-info">
              <h4>Adaptive Intelligent<br/>Interface</h4>
              <p class="desc">The interface supports up to 15 languages and<br/>
                features 3 adjustable screen brightness levels,<br/>
                making it adaptable to various clinical environments.</p>
            </div>
            <div class="language-img">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/9db9095422044f357599979a45b4fda8.png" alt="">
            </div>
            <div class="screen-img">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/11852b81f2ccc9fc2105f07f257d0f3e.png" alt="">
            </div>
          </div>
        </div>
      </div>


      <div class="dental-cart-container">
        <div class="dental-cart-info">
          <h4>Mobile<br/>
            Dental Cart</h4>
          <p class="desc">Neatly stores external tubing<br/>and cables fora clutter-free<br/>workspace, making your<br/>device readily accessible.</p>
        </div>
        <div class="dental-cart-img">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/bddefe03aba17b3d5ffd8db8ba210de7.png" alt="">
        </div>
      </div>


      <div class="maintenance-reminder-container">
        <div class="maintenance-reminder-info">
          <h4>Smart Maintenance<br/>
            Reminder</h4>
          <p class="desc">Monitors usage and alerts you for airstream cord or<br/>
            powder container maintenance, ensuring optimal<br/>
            performance for seamless workflows</p>
        </div>
        <div class="maintenance-reminder-img">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/681c0b34a6a8cdf930dbd10078a67bdb.png" alt="">
        </div>
        <div class="glow"></div>
      </div>


      <div class="accessories-container">
        <div class="accessories-content">
          <p class="accessories">Accessories</p>
          <div class="accessories-img">
            <div class="txt">
              <div>
                <p>Periodontal<br/>
                  treatment<br/>
                  handpiece</p>
                <p>31.08.01.009</p>
              </div>
              <div>
                <p>Airstreaming<br/>supragingival<br/>handpiece</p>
                <p>31.16.20.086-002</p>
              </div>
              <div>
                <p>Airstreaming<br/>supragingival<br/>handpiece</p>
                <p>31.16.20.087</p>
              </div>
              <div>
                <p>lluminated powder<br/>container<br/>(Sodium bicarbonate)</p>
                <p>31.16.06.216-008</p>
              </div>

              <div>
                <p>Illuminated powder<br/>container<br/>
                  (Erythritol/Glycine)</p>
                <p>31.16.06.219-008</p>
              </div>
              <div>
                <p>Wireless<br/>multi-function<br/>foot pedal</p>
                <p>31.16.06.153</p>
              </div>
              <div>
                <p>O-ring kit</p>
                <p>31.16.06.241</p>
              </div>
            </div>
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260708/52e50cdc34e1e889d436552d9c0ba737.png" alt="">
          </div>

          <div class="parameters-content">
            <p class="tit">parameters</p>
            <p class="txt">
              Output main vibration offset of tip (maximum): 90um; deviation: +50%<br/>Output vibrating frequency of tip: 30+5kHz<br/>
              Output semi-offset force: 10N; deviation: +50%<br/>
              Output power of tip: 3W ~ 20w<br/>
            </p>
          </div>
        </div>

      </div>


      <video-modal ref="videoModalRef"></video-modal>

    </div>
  </div>
</template>

<script>

import circularProgress from "../components/progress-circle.vue";
import videoModal from '../components/video-modal.vue'

import viewButton from './components/button.vue'
export default {
  components: {
    circularProgress,
    videoModal,
    viewButton
  },
  name: 'pt-e',
  data(){
    return {
      videoList: [
        {
          ref: 'promotionalRef',
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/54b299425001834810463984535/vcBaQkxCZg0A.mp4',
          progress: 0,
          playing: false,
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/1dc746d05001834811221681017/hD1geWMZ7fQA.mp4',
          hasEntered: false,
          hasLeft: false
        }
      ],
    }
  },
  methods: {
    handleVisibility(isVisible, index) {
      const ref = this.videoList[index].ref;
      if (isVisible && !this.videoList[index].hasEntered) {
        this.$refs[ref].play().catch(e => console.log(ref + "视频播放失败:", e));
        this.videoList[index].playing = true
        this.videoList[index].hasEntered = true
        this.videoList[index].hasLeft = false
      } else if (!isVisible && !this.videoList[index].hasLeft) {
        this.$refs[ref].pause()
        this.videoList[index].playing = false
        this.videoList[index].hasLeft = true
        this.videoList[index].hasEntered = false
      }
    },
    togglePlay(index) {
      const ref = this.videoList[index].ref;
      this.videoList[index].playing = !this.videoList[index].playing;
      if(this.videoList[index].playing){
        this.$refs[ref].play().catch(e => console.log(ref + "视频播放失败:", e));
      }else {
        this.$refs[ref].pause();
      }
    },
    openVideoModal(url){
      this.$refs.videoModalRef.open(url)
    },
  }
};
</script>

<style>

h1, h2, h3, h4, h5, h6, p {
  padding: 0;
  margin: 0;
}

.pt-e-detail h1, .pt-e-detail h2, .pt-e-detail h3 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: .5rem;
  color: #1B1B1B ;
}

.pt-e-detail h4, .pt-e-detail h5, .pt-e-detail h6 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: .355rem;
  color: #1B1B1B ;
}

.pt-e-detail p {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: .24rem;
  color: #7d7d7d ;
  margin: 0;
  padding: 0;
}

.ph-special-main {
  background: #FFF;
  padding-top: 0;
}
.ph-special-main .pt-e-detail {}
.ph-special-main .pt-e-detail .desc {
  font-size: .248rem;
  line-height: 1.3;
}
.ph-special-main .pt-e-detail img {
  display: block;
  width: 100%;
}

.ph-special-main .pt-e-detail .pt-e-banner {
  position: relative;
}

.ph-special-main .pt-e-detail .pt-e-banner .button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: .71rem 0 .47rem 0;
}
.ph-special-main .pt-e-detail .pt-e-banner .pt-e-banner-txt {
  position: absolute;
  width: 100%;
}

.ph-special-main .pt-e-detail .pt-e-banner .pt-e-banner-txt .p-title {
  width: 2.8rem;
  margin: 1.43rem auto 0 auto;
}

.ph-special-main .pt-e-detail .pt-e-banner .pt-e-banner-txt p {
  text-align: center;
  font-size: .25rem;
  margin-top: .3rem;
  color: #ffffff;
}

.ph-special-main .promotional-cover {
  position: relative;
}
.ph-special-main .promotional-cover .background-video {
  width: 100%;
  display: block;
}

.ph-special-main .promotional-cover .progress {
  position: absolute;
  right: 40px;
  top: 20px;
  z-index: 5;
}

.ph-special-main .power-container {
  padding: .65rem .65rem .55rem .65rem;
}
.ph-special-main .power-container .tit {
  font-size: .5rem;
  background: linear-gradient(
      90deg,
      #8000ff 0%,
      #9933ff 10%,
      #b366ff 25%,
      #cc99ff 40%,
      #e6ccff 60%,
      #f5e6ff 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.ph-special-main .pt-e-detail .power-container h4 {
  font-size: .355rem;
  margin-top: .37rem;
}

.ph-special-main .pt-e-detail .power-container .desc{
  //margin-top: .16rem;
}

.ph-special-main .pt-e-detail .power-container .num {
  font-size: .48rem;
  background: linear-gradient(
      90deg,
      #8000ff 0%,
      #9933ff 1%,
      #b366ff 5%,
      #cc99ff 10%,
      #e6ccff 60%,
      #f5e6ff 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.pt-e-detail .power-container .model {
  background: linear-gradient(to bottom, #ffffff, #f5f5fa);
  position: relative;
}
.pt-e-detail .power-container .model p {
  font-size: .14rem;
  top: 1rem;
}

.pt-e-detail .power-container .model-tit {
  position: absolute;
}
.pt-e-detail .power-container .model-tit.previous {
  left: .1rem;
}
.pt-e-detail .power-container .model-tit.new {
  left: 4.87rem;
}


.pt-e-detail .feature-container {
  position: relative;
}
.pt-e-detail .feature-content {
  position: absolute;
  top: .6rem;
  left: .7rem;
  width: 100%;
}
.pt-e-detail .feature-content p {
  font-size: .24rem;
  color: #ffffff;
}

.pt-e-detail .feature-content p:nth-child(4){
  margin-top: .3rem;
}
.pt-e-detail .feature-content p:nth-child(5) {
  font-size: .5rem;
  margin-top: .1rem;
}

.pt-e-detail .feature-content .params {

}

.pt-e-detail .feature-content .params div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #dcd4ff;
  padding: 5px 15px;
}

.pt-e-detail .feature-content .params {

}

.pt-e-detail .feature-content .params p {
  font-size: .12rem;
}

.pt-e-detail .feature-content .pt-e-c {
  margin-top: .2rem;
}
.pt-e-detail .feature-content .params .pt-e {
  width: 2rem;
}
.pt-e-detail .feature-content .params .Standard p,
.pt-e-detail .feature-content .params .pt-e p {
  color: #000000;
  font-size: .12rem;
}

.pt-e-detail .feature-content .Standard-c {
  margin-top: .1rem;
}
.pt-e-detail .feature-content .params .Standard {
  width: 2.92rem;
  margin-top: .1rem;
}

.ph-special-main .pt-e-detail .feature-content .params .tit {
  margin-top: .05rem;
  font-size: .14rem;
}

.ph-special-main .pt-e-detail .heating-system-container,
.ph-special-main .pt-e-detail .upgraded-airstream-container {
  padding: 1.35rem .65rem .5rem .65rem;
}

.ph-special-main .pt-e-detail .heating-system-container p {
  font-size: .24rem;
  margin-top: .2rem;
  line-height: 1.6;
}


.ph-special-main .pt-e-detail .upgraded-airstream-container p {
  font-size: .24rem;
  margin-top: .2rem;
  line-height: 1.8;
}


.ph-special-main .pt-e-detail .titanium-alloy-container {
  position: relative;
}

.ph-special-main .pt-e-detail .titanium-alloy-container .titanium-alloy-content {
  padding: 1.55rem .65rem .5rem .65rem;
  position: absolute;
}

.ph-special-main .pt-e-detail .titanium-alloy-container p {
  line-height: 1.8;
  margin-top: .2rem;
}

.ph-special-main .pt-e-detail .titanium-alloy-container .titanium-alloy-img {
  padding-top: .5rem;
}


.ph-special-main .pt-e-detail .precision-container {
  padding: .48rem .65rem .55rem .74rem;
}
.ph-special-main .pt-e-detail .precision-container h4 {
  margin-top: .75rem;
}

.ph-special-main .pt-e-detail .precision-container .desc{
  margin-top: .09rem;
}

.ph-special-main .pt-e-detail .precision-container .step-use {}
.ph-special-main .pt-e-detail .precision-container .step-use .step-item {
  position: relative;
  width: 4.6rem;
  margin: .8rem auto 0 auto;
}

.ph-special-main .pt-e-detail .precision-container .step-use .step-item .letter {
  position: absolute;
  left: 50%;
  top: -0.8rem;
  transform: translateX(-50%);
  font-size: 1.2rem;
  color: #f46c62;
}
.ph-special-main .pt-e-detail .precision-container .step-use .step-item .explain-c {
  position: absolute;
  top: 2rem;
  left: 0;
  width: 100%;
}
.ph-special-main .pt-e-detail .precision-container .step-use .step-item .explain-c .explain-b {
  display: flex;
  //justify-content: space-between;
  padding: 0 0 0 .5rem;
  position: relative;
}

.ph-special-main .pt-e-detail .precision-container .step-use .step-item .explain-c .explain-b div:nth-child(2){
  left: 2.8rem;
  position: absolute;
}

.ph-special-main .pt-e-detail .precision-container .step-use .step-item:nth-child(2) .explain-c .explain-b div:nth-child(2){
  left: 2.75rem;
  position: absolute;

}

.ph-special-main .pt-e-detail .precision-container .step-use .step-item:nth-child(3) .explain-c .explain-b div:nth-child(2){
  left: 2.85rem;
  position: absolute;
}

.ph-special-main .pt-e-detail .precision-container .step-use .step-item .explain-c .explain-b div p:nth-child(2) {
  font-size: .12rem;
  margin-top: .17rem;
  line-height: 1.5;
  color: #808080;
}

.ph-special-main .pt-e-detail .precision-container .step-use .step-item:nth-child(2) .explain-c .explain-b div:nth-child(2) p:nth-child(2) {
  margin-top: 0;
}

.ph-special-main .pt-e-detail .precision-container .step-use .step-item:nth-child(3) .explain-c .explain-b {
  padding: 0 0 0 .5rem;
}


.ph-special-main .pt-e-detail .precision-container .step-use .step-item .explain-c .explain-b .explain-tit {
  font-size: .18rem;
  color: #575656;
}

.ph-special-main .pt-e-detail .scaling {
  margin-top: -0.9rem;
}


.ph-special-main .pt-e-detail .convenience-container {
  position: relative;
}
.ph-special-main .pt-e-detail .convenience-container .convenience-content {
  position: absolute;
  width: 100%;
  top: 1.45rem;

}

.ph-special-main .pt-e-detail .convenience-container .convenience-content .main-txt {
  padding-left: .65rem;
}

.ph-special-main .pt-e-detail .convenience-container .convenience-content .tit {
  background: linear-gradient(
      90deg,
      #dfcfff 0%,
      #baa3e7 39%,
      #a88edb 50%,
      #977ad1 75%,
      #8a6bc8 80%,
      #7f5dc1 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.ph-special-main .pt-e-detail .convenience-container .convenience-content h4 {
  color: #ffffff;
  margin-top: .5rem;
}

.ph-special-main .pt-e-detail .convenience-container .convenience-content .desc {
  color: #ffffff;
  margin-top: .3rem;
  line-height: 1.7;
}

.ph-special-main .pt-e-detail .convenience-container .convenience-content .params {
  display: flex;
  padding-left: .65rem;
}
.ph-special-main .pt-e-detail .convenience-container .convenience-content .params p{
  font-size: .5rem;
  color: #ffffff;
}
.ph-special-main .pt-e-detail .convenience-container .convenience-content .params p:last-child{
  margin-left: .55rem;
}

.ph-special-main .pt-e-detail .powder-container {
  margin-top: 6.49rem;
}
.ph-special-main .pt-e-detail .powder-container .powder-container-info {
  padding-left: .65rem;
}
.ph-special-main .pt-e-detail .powder-container .powder-container-info .desc {
  margin-top: 0.2rem;
}

.ph-special-main .pt-e-detail .clinical-operations {
  background-color: #000000;
  padding-top: .3rem;
}
.ph-special-main .pt-e-detail .clinical-operations .clinical-operation {
  width: 6rem;
  margin: 0 auto 0 auto;
}

.ph-special-main .pt-e-detail .clinical-operations .clinical-operation:nth-child(2){
  margin-top: .35rem;
}
.ph-special-main .pt-e-detail .clinical-operations .clinical-operation p {
  margin-top: .1rem;
  font-size: .19rem;
  color: #ffffff;
}

.ph-special-main .pt-e-detail .convenience-upgraded {
  background-color: #000000;
  overflow: hidden;
  position: relative;
}

.ph-special-main .pt-e-detail .convenience-upgraded .convenience-upgraded-content {
  position: relative;
  z-index: 2;
}
.ph-special-main .pt-e-detail .convenience-upgraded .convenience-upgraded-container {
  display: flex;
  justify-content: space-between;
  padding: .65rem .81rem .82rem;
}
.ph-special-main .pt-e-detail .convenience-upgraded .convenience-upgraded-container .before,
.ph-special-main .pt-e-detail .convenience-upgraded .convenience-upgraded-container .after {
  width:2.47rem;
}
.ph-special-main .pt-e-detail .convenience-upgraded .convenience-upgraded-container .before p,
.ph-special-main .pt-e-detail .convenience-upgraded .convenience-upgraded-container .after p {
  color: #ffffff;
  text-align: center;
  margin-top: .15rem;
  font-size: .18rem;
}
.ph-special-main .pt-e-detail .convenience-upgraded .convenience-upgraded-container .before {

}
.ph-special-main .pt-e-detail .convenience-upgraded .convenience-upgraded-container .after {

}
.ph-special-main .pt-e-detail .convenience-upgraded .ps {
  padding: .95rem 0 0 .65rem;
}
.ph-special-main .pt-e-detail .convenience-upgraded .ps h4 {
  color: #ffffff;
}

.ph-special-main .pt-e-detail .convenience-upgraded .ps .desc {
  line-height: 1.8;
  color: #ffffff;
}

.ph-special-main .pt-e-detail .convenience-upgraded .glow {
  position: absolute;
  width: 16rem;
  height: 16rem;
  bottom: -9rem;
  border-radius: 50%;
  left: 50%;
  transform: translateX(-50%);
  //background: rgba(84,67,118,0.7);
  z-index: 1;
  background: radial-gradient(circle at center, rgba(87, 69, 122,.6) 20%, transparent 60%), #000000;
}


.ph-special-main .pt-e-detail .intelligent-interface {
  background: linear-gradient(180deg, #030207 0%, #0a0614 35%, #120a24 70%, #1a1035 100%);
  padding-bottom: 1.05rem;
}
.ph-special-main .pt-e-detail .intelligent-interface .intelligent-interface-container {}
.ph-special-main .pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info {
  padding: 1rem 0 0 .65rem;
}
.ph-special-main .pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info h4 {
  color: #ffffff;
}
.ph-special-main .pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info p {
  color: #ffffff;
  margin-top: .25rem;
  line-height: 1.6;
}
.ph-special-main .pt-e-detail .intelligent-interface .intelligent-interface-container .language-img {
  width: 3.65rem;
  margin: .4rem auto 0 auto;
}
.ph-special-main .pt-e-detail .intelligent-interface .intelligent-interface-container .screen-img {
  width: 3.75rem;
  margin: .4rem auto 0 auto;
}

.ph-special-main .pt-e-detail .dental-cart-container {
  position: relative;
  background:
      radial-gradient(ellipse 100% 45% at 50% 100%, rgba(130, 70, 200, 0.45) 0%, rgba(90, 45, 160, 0.25) 40%, transparent 70%),
      #000000;
}
.ph-special-main .pt-e-detail .dental-cart-container .dental-cart-info {
  position: absolute;
  left: .65rem;
  top: .95rem;
}
.ph-special-main .pt-e-detail .dental-cart-container .dental-cart-info h4 {
  color: #ffffff;
}
.ph-special-main .pt-e-detail .dental-cart-container .dental-cart-info .desc {
  margin-top: .25rem;
  line-height: 1.6;
  color: #ffffff;
}


.ph-special-main .pt-e-detail .maintenance-reminder-container {
  background:
      radial-gradient(ellipse 100% 40% at 50% 100%, rgba(140, 80, 210, 0.4) 0%, rgba(100, 50, 170, 0.2) 50%, transparent 70%),
      linear-gradient(to top, rgba(180, 120, 255, 0.15) 0%, transparent 40%),
      linear-gradient(180deg, #0a0615 0%, #120a25 40%, #1a1035 75%, #221645 100%);
  position: relative;
}
.ph-special-main .pt-e-detail .maintenance-reminder-container .maintenance-reminder-info {
  position: absolute;
  top: .85rem;
  left: .65rem;
}
.ph-special-main .pt-e-detail .maintenance-reminder-container .maintenance-reminder-info h4 {
  color: #ffffff;
}
.ph-special-main .pt-e-detail .maintenance-reminder-container .maintenance-reminder-info .desc {
  color: #ffffff;
  margin-top: .24rem;
  line-height: 1.6;
}

.ph-special-main .pt-e-detail .accessories-container {
  background-color: #000000;
  padding-bottom: 1.3rem;
}
.ph-special-main .pt-e-detail .accessories-container .accessories-content {
}
.ph-special-main .pt-e-detail .accessories-container .accessories-content .accessories-img {
  position: relative;
  width: 6.2rem;
  margin: .4rem auto 0 auto;
  position: relative;
}
.ph-special-main .pt-e-detail .accessories-container .accessories-content .accessories-img .txt {
  position: absolute;
}

.ph-special-main .pt-e-detail .accessories-container .accessories-content p {
  color: #ffffff;
}

.ph-special-main .pt-e-detail .accessories-container .accessories-content .accessories {
  font-size: .2rem;
  padding: .75rem 0 0 .65rem;
}

.ph-special-main .pt-e-detail .accessories-container .accessories-content .accessories-img .txt div p {
  font-size: .16rem;
  white-space: nowrap;
  color: #b3b3b3;
}

.ph-special-main .pt-e-detail .accessories-container .accessories-content .accessories-img .txt div p:nth-child(2){
  font-size: .125rem;
  margin-top: .2rem;
}

.ph-special-main .pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(1) {
  position: absolute;
  left: .89rem;
  top: .21rem;
}
.ph-special-main .pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(2) {
  position: absolute;
  left: 2.75rem;
  top: .21rem;
}
.ph-special-main .pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(3) {
  position: absolute;
  left: 4.85rem;
  top: .21rem;
}
.ph-special-main .pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(4) {
  position: absolute;
  left: 1.1rem;
  top: 1.78rem;
}

.ph-special-main .pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(5) {
  position: absolute;
  left: 4.3rem;
  top: 1.85rem;
}

.ph-special-main .pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(6) {
  position: absolute;
  left: 1.1rem;
  top: 3.49rem;
}
.ph-special-main .pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(7) {
  position: absolute;
  left: 4.85rem;
  top: 3.49rem;
}

.ph-special-main .pt-e-detail .accessories-container .accessories-content .parameters-content {
  padding: .67rem 0 0 .65rem;
}
.ph-special-main .pt-e-detail .accessories-container .accessories-content .parameters-content .tit {
  font-size: .2rem;
}
.ph-special-main .pt-e-detail .accessories-container .accessories-content .parameters-content .txt {
  font-size: .172rem;
  margin-top: .2rem;
  line-height: 2;
  color: #b3b3b3;
}
</style>